import React from 'react'

const StatusSecond = ({ color = '#1E1E1E' }: { color?: string }) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.72656 3.08014V6.90796C4.72656 8.54208 6.05127 9.86679 7.68539 9.86679M10.6442 3.08014V6.90796C10.6442 8.54208 9.31951 9.86679 7.68539 9.86679M7.65612 3.08014V7.07443M7.68539 9.86679V20.9198M19.2734 20.9198L19.2734 3.08014C19.2734 3.08014 14.6443 3.08014 14.6443 11.8079V15.9981H16.7676'
        stroke={color}
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default StatusSecond
